import { message } from 'antd';
import { useEffect, useState } from 'react';

import { ReportsTable } from '../../pages/private/reports/styles';
import { columns } from './columns';
import {
  useGetLoginTokensQuery,
  useRevokeTokenMutation,
} from '../../services/authApi';

export function LoginTokens() {
  const [
    revoke,
    {
      isLoading: isLoadingLogin,
      isSuccess: isSuccessRevoke,
      isError: isErrorRevoke,
    },
  ] = useRevokeTokenMutation();
  const [queryPage, setQueryPage] = useState(1);
  const [queryPageSize, setQueryPageSize] = useState(15);

  const [filters, setFilters] = useState({
    page: queryPage,
    page_size: 15,
  });

  useEffect(() => {
    setFilters((prev: any) => ({
      ...prev,
      page: queryPage,
      page_size: queryPageSize,
    }));
  }, [queryPage, queryPageSize]);

  const { data: loginTokens, refetch: refetchLoginTokens } =
    useGetLoginTokensQuery(filters);

  async function onBlock(token: any) {
    const tokenRevoke = await revoke(token?.id);
    refetchLoginTokens();
  }

  useEffect(() => {
    if (isSuccessRevoke) {
      message.success('Token de acesso bloqueado sucesso!');
    }

    if (isErrorRevoke) {
      message.error('Erro ao bloquear token de acesso!');
    }
  }, [isSuccessRevoke, isErrorRevoke]);

  return (
    <ReportsTable
      columns={columns(onBlock)}
      dataSource={loginTokens?.results}
      pagination={{
        position: ['bottomCenter'],
        defaultPageSize: loginTokens?.results?.length,
        total: loginTokens?.count,
        onChange: (page) => setQueryPage(page),
        current: queryPage,
      }}
      scroll={{ y: 610, scrollToFirstRowOnChange: false }}
    />
  );
}
